import { render, staticRenderFns } from "./descriptionOfGoods.vue?vue&type=template&id=5fda6742&"
import script from "./descriptionOfGoods.vue?vue&type=script&lang=js&"
export * from "./descriptionOfGoods.vue?vue&type=script&lang=js&"
import style0 from "./descriptionOfGoods.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports